<div class="fui-layout-container">
  <fui-layout-header [breadcrumbs]="breadcrumbs" headingText="fui-header.exchange" description="newdash.exchange_description">
    <div class="d-flex align-items-center justify-content-between m-t-30 flex-wrap">
      <div class="fui-nav-pills w-full">
        <ul>
          <li>
            <button [class.active]="displayedSection == 'featured'" (click)="switchSection('featured')" (keyup.enter)="switchSection('featured')" (keyup.space)="switchSection('featured')">
              {{ "exchange.featured_artist_content" | translate }}
            </button>
          </li>
          <li>
            <button [class.active]="displayedSection == 'browse'" (click)="switchSection('browse')" (keyup.enter)="switchSection('browse')" (keyup.space)="switchSection('browse')">
              {{ "exchange.browse_user_content" | translate }}
            </button>
          </li>
          <li>
            <button [class.active]="displayedSection == 'myitems'" (click)="switchSection('myitems')" (keyup.enter)="switchSection('myitems')" (keyup.space)="switchSection('myitems')">
              {{ "exchange.my_items" | translate }}
            </button>
          </li>
          <li>
            <button [class.active]="displayedSection == 'myfavorites'" (click)="switchSection('myfavorites')" (keyup.enter)="switchSection('myfavorites')" (keyup.space)="switchSection('myfavorites')">
              {{ "exchange.favorites" | translate }}
            </button>
          </li>
        </ul>
        <button class="fui-action-btn m-y-5" (click)="uploadWare()">
          <fa-icon icon="plus"></fa-icon>
          {{ "general.upload" | translate }}
        </button>
      </div>
    </div>
  </fui-layout-header>
  <hr />
  @if (displayedSection == "browse") {
    <div class="fui-layout-pad-content">
      @if (browseExchange) {
        <fui-content-filter
          #fuiContentFilter
          [activeQuery]="browseExchange.query"
          (refineClicked)="showFilterOptions = !showFilterOptions"
          [resultsCount]="browseExchange.displayedCategory ? browseExchange.displayedCategory.total : 0"
          (clearQuery)="browseExchange.query = ''"
          [searchOnlyOnEnter]="true"
          [showSortOptionsToggle]="false"
          (queryChanged)="browseExchange.query = $event; browseExchange.search()"
          (showMobileFiltersClicked)="showFilterOptions = true; fuiSidebarFilter?.showMobileModal()"
        ></fui-content-filter>
      }
    </div>
  }
  @if (displayedSection == "featured") {
    <div class="fui-layout-edge-content">
      <myp-featured-creators [featuredCreators]="featuredCreators" (creatorClicked)="goToCreator($event)"></myp-featured-creators>
    </div>
  }
  @if (displayedSection == "browse") {
    <div class="fui-layout-edge-content refine-content">
      <hr />
      <div class="fui-sidebar-content-container">
        <fui-sidebar-filter
          #fuiSidebarFilter
          [visible]="showFilterOptions"
          [showSkeleton]="!browseCategories?.length"
          [skeletonConfig]="{ number: 18, extraContainerClass: 'm-y-20', type: 'line', useRandomWidth: true, height: '10px' }"
          [showHideButton]="true"
          hideButtonText="Hide Filters"
          hideButtonIcon="chevron-left"
          (hideClicked)="showFilterOptions = false"
        >
          <ng-container *ngTemplateOutlet="filterContent"></ng-container>
        </fui-sidebar-filter>
        <div class="w-full">
          <exc-browse-exchange
            [showCategories]="false"
            #browseExchange
            (searchEnterPressed)="appService.mobileMenuShown = false"
            (categoriesInitted)="browseCategories = $event"
            (exchangeItemTapped)="viewExchangeDetail($event)"
          ></exc-browse-exchange>
        </div>
      </div>
    </div>
  }
  @if (displayedSection == "myitems") {
    <div class="fui-layout-pad-content">
      <myp-creator (exchangeAssetClicked)="viewExchangeDetail($event)" [showEditProfile]="true" [creator]="user" [showNav]="false"></myp-creator>
    </div>
  }
  @if (displayedSection == "myfavorites") {
    <div class="fui-layout-pad-content">
      @if (loading) {
        <myp-skeleton-loader type="product-tile" height="250px" [number]="6" class="grid-container pad-10"></myp-skeleton-loader>
      }
      @if (!loading && displayedWares.data.length) {
        <div>
          <myp-exchange-list
            (itemTapped)="viewExchangeDetail($event)"
            [displayedCategory]="{ title: 'favorites', display_name: 'MY FAVORITES' }"
            (updateFavorites)="loadFavorites($event)"
            [limit]="limit"
            [page]="page"
            [wares]="displayedWares"
          ></myp-exchange-list>
        </div>
      }
      @if (!loading && !displayedWares.data.length) {
        <div class="m-y-50">
          {{ "sphere.no_favorites" | translate }}
        </div>
      }
    </div>
  }
  <div class="m-t-100 p-b-50">
    <fui-footer></fui-footer>
  </div>
</div>

<ng-template #filterContent>
  <ul>
    @for (cat of browseCategories; track cat) {
      <li class="fui-primary-category" [class.selected]="cat.active">
        <a
          tabindex="0"
          href="javascript:void(0);"
          [class.active]="cat.active"
          (keyup.enter)="browseExchange.switchCategory(cat)"
          (keyup.space)="browseExchange.switchCategory(cat)"
          (click)="appService.mobileMenuShown = false; browseExchange.switchCategory(cat)"
        >
          <img [src]="'./assets/icons/exchange/' + cat.title + '-category.png'" class="icon dark-bg" />
          {{ cat.display_name }}
          <span class="list-item-badge">{{ cat.total }}</span>
        </a>
      </li>
    }
  </ul>
</ng-template>

<!-- Modal template for mobile filter -->
<ng-template #sidebarFilterModal let-modal>
  <div class="modal-body fui-sidebar-filter-mobile">
    <ng-container *ngTemplateOutlet="filterContent"></ng-container>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" (click)="modal.close()">{{ "education.done" | translate }}</button>
  </div>
</ng-template>
